import React, { useState, useEffect } from "react";
import {
  CloudUploadIcon,
  AlertIcon,
  EditIcon,
  ExpandIcon,
} from "../../../../images/icons/icons";

const FormFileUpload = ({
  label,
  name,
  accept,
  onChange,
  error,
  disabled = false,
  required = false,
  onRef,
  existingFile,
  onViewFile,
  value,
  className = "",
  isApproval = false,
  isEdit = false,
}) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isImage, setIsImage] = useState(false);

  const hasValue = (value) => {
    if (typeof value === "string") return value.trim() !== "";
    if (value instanceof File) return true;
    return value !== null && value !== undefined && value !== "";
  };

  const hasFile = hasValue(value) || hasValue(existingFile);

  const handleEdit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const fileInput = document.getElementById(name);
    if (fileInput) {
      fileInput.click();
    }
  };

  const handleExpand = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const fileUrl = existingFile || previewUrl || value;
    if (!fileUrl) return;

    if (isImage) {
      if (onViewFile) {
        onViewFile(fileUrl, label);
      }
    } else {
      const link = document.createElement("a");
      link.href =
        typeof fileUrl === "string" ? decodeURIComponent(fileUrl) : fileUrl;
      link.target = "_blank";
      link.download = label || "document";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  useEffect(() => {
    if (value instanceof File) {
      const url = URL.createObjectURL(value);
      setPreviewUrl(url);
      setIsImage(value.type.startsWith("image/"));
      return () => URL.revokeObjectURL(url);
    } else {
      const fileUrl = existingFile || value;
      if (fileUrl && typeof fileUrl === "string") {
        setPreviewUrl(fileUrl);
        const decodedUrl = decodeURIComponent(fileUrl);
        const extension = decodedUrl.split(".").pop()?.toLowerCase();
        const isImageFile = ["jpg", "jpeg", "png", "gif", "webp"].includes(
          extension
        );
        setIsImage(isImageFile);
      } else {
        setPreviewUrl(null);
        setIsImage(false);
      }
    }
  }, [value, existingFile]);

  return (
    <div className={`staff-onboarding-form-group ${className}`}>
      <label className="staff-onboarding-form-label">
        <CloudUploadIcon color="#6B7280" />
        <span className="staff-onboarding-label-text">
          {label}{" "}
          {required && <span className="staff-onboarding-required">*</span>}
        </span>
      </label>

      <div
        className={`staff-onboarding-file-upload ${error ? "error" : ""} ${
          disabled ? "disabled" : ""
        } ${hasFile ? "has-file" : ""}`}
      >
        <input
          ref={onRef}
          type="file"
          name={name}
          accept={accept}
          onChange={onChange}
          disabled={disabled}
          className="staff-onboarding-file-input"
          id={name}
        />

        {hasFile && isImage && previewUrl ? (
          <div className="staff-onboarding-file-preview">
            <img
              src={decodeURIComponent(previewUrl)}
              alt={`Preview of ${label}`}
              className="staff-onboarding-preview-image"
            />
            <div className="staff-onboarding-file-actions">
              <button
                type="button"
                onClick={handleEdit}
                className="staff-onboarding-action-btn edit-btn"
                disabled={disabled}
                title="Edit/Replace file"
              >
                <EditIcon />
              </button>
              {(isApproval || isEdit) && (
                <button
                  type="button"
                  onClick={handleExpand}
                  className="staff-onboarding-action-btn expand-btn"
                  title="Zoom image"
                >
                  <ExpandIcon />
                </button>
              )}
            </div>
          </div>
        ) : hasFile ? (
          <div className="staff-onboarding-file-preview non-image">
            <div className="staff-onboarding-file-icon">
              <CloudUploadIcon color="#059669" />
            </div>

            <div className="staff-onboarding-file-actions">
              <button
                type="button"
                onClick={handleEdit}
                className="staff-onboarding-action-btn edit-btn"
                disabled={disabled}
                title="Edit/Replace file"
              >
                <EditIcon />
              </button>
              {/* {(isApproval || isEdit) && (
                <button
                  type="button"
                  onClick={handleExpand}
                  className="staff-onboarding-action-btn expand-btn"
                  title="Download file"
                >
                  <ExpandIcon />
                </button>
              )} */}
            </div>
            <div className="staff-onboarding-file-info">
              <span className="staff-onboarding-file-name">
                {value?.name || "Current file"}
              </span>
              
              {onViewFile && (
                <span
                  onClick={() => onViewFile(existingFile || previewUrl, label)}
                  style={{
                    color: "#3B82F6",
                    textDecoration: "underline",
                    cursor: "pointer",
                    marginLeft: "8px",
                  }}
                >
                  view
                </span>
              )}
            </div>
          </div>
        ) : (
          <label htmlFor={name} className="staff-onboarding-file-upload-label">
            <CloudUploadIcon color="#6B7280" />
            <span>Choose file</span>
            <small>{accept}</small>
          </label>
        )}

        {error && (
          <div className="staff-onboarding-error-message">
            <AlertIcon color="#EF4444" />
            <span>{error}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormFileUpload;
